import { gql, TypedDocumentNode } from '@common/hooks';
import {
  MissionControlPaginatedStaffingRequestApplicationsQueryCgResponse,
  MissionControlPaginatedStaffingRequestApplicationsQueryVariables,
} from '@common/graphql';

export type MissionControlStaffingRequestApplicationType = NonNullable<
  MissionControlPaginatedStaffingRequestApplicationsQueryCgResponse['missionControlPaginatedStaffingRequestApplications']['staffingRequestApplications']
>[number];

export const MISSION_CONTROL_PAGINATED_STAFFING_REQUEST_APPLICATIONS_QUERY: TypedDocumentNode<
  MissionControlPaginatedStaffingRequestApplicationsQueryCgResponse,
  MissionControlPaginatedStaffingRequestApplicationsQueryVariables
> = gql`
  query MissionControlPaginatedStaffingRequestApplications(
    $limit: Int!
    $offset: Int!
    $orderDirection: OrderDirection
    $orderField: MissionControlStaffingRequestApplicationOrderField
    $filters: StaffingRequestApplicationFilterInput
    $states: [StaffingRequestApplicationState!]
  ) {
    missionControlPaginatedStaffingRequestApplications(
      limit: $limit
      offset: $offset
      orderDirection: $orderDirection
      orderField: $orderField
      filters: $filters
      states: $states
    ) {
      totalCount
      staffingRequestApplications {
        id
        state
        createdAt
        ageOfOfferInSeconds
        ageOfOfferType
        availableToStartAt
        secondsUntilStartDate
        timeUntilStartDateType
        activeOffer {
          id
          state
          canRetract {
            value
          }
        }
        worksProfile {
          id
          fullName
          firstName
          lastName
        }
        staffingRequest {
          id
          code
          state
          role {
            id
            abbreviation
          }
          organizationUnit {
            id
            clinicalUnit {
              id
              displayName
            }
          }
          organizationBusiness {
            id
            name
          }
          startDate
          openStaffingRequestPositionsCount
        }
        supplier {
          id
          name
        }
        worksSubmittalPacket {
          id
        }
      }
    }
  }
`;
